import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Supplier } from 'contracts/Supplier';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_SUPPLIER_',
  }
);

export interface FetchSupplierState {
  data: Supplier | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchSupplierRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Supplier;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchSupplierState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchSupplierState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchSupplierState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchSupplierState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchSupplierState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchSupplier = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchSupplierTypes = Types;
export const FetchSupplierActions = Creators;
